/**
 * This file was copied from dashboard into clowncar as part of a cleanup effort
 */
import supportedCountries from '@tock/shared/utils/supportedCountries';

export function getLocales(countryInput: string) {
  const country = countryInput.toUpperCase();
  return supportedCountries[country] ? supportedCountries[country].locales : [];
}

export function getDefaultLocale(country: string) {
  const locales = getLocales(country);
  return locales.length > 0 && locales[0].value;
}
